import { smbIntakeSchema, type SmbIntake } from "./smb-intake";

const full: SmbIntake = {
  externalId: "fixture-local-service", contact: { email: "client@example.com", name: "Fixture Client" },
  brand: { name: "Example Local Plumbing", url: "https://example.com" },
  logos: ["https://example.com/logo.png"], colors: ["#036", "#FFD700", "fff"],
  services: [{ name: "Drain cleaning", description: "Local residential drain cleaning", url: "https://example.com/services" }],
  serviceAreas: ["Austin, TX", "Within 25 miles of Austin"],
  promotions: [{ title: "Spring service check", details: "Ask about seasonal availability", code: "SPRING",
    startsOn: "2027-03-01", endsOn: "2027-04-30" }],
  socials: { facebook: "https://www.facebook.com/example", instagram: "https://www.instagram.com/example", other: [] },
  idealCustomer: { summary: "Local homeowners", location: "Austin", ageRange: "30-65",
    painPoints: ["Unreliable appointment windows"], notes: "Values clear estimates" },
  localCompetitors: [{ name: "Example Competitor", url: "https://example.org" }],
  referenceImages: ["https://example.com/team.jpg"], notes: "Test fixture only. No paid work is started by intake.",
};
export const SMB_INTAKE_FIXTURES = [
  { key: "full", label: "Full local service", input: smbIntakeSchema.parse(full) },
  { key: "no-logo", label: "Minimal, no logo", input: smbIntakeSchema.parse({
    externalId: "fixture-minimal-service", contact: full.contact, brand: { name: "Example Cleaning" },
    logos: [], colors: ["abc"], services: [{ name: "House cleaning" }], serviceAreas: ["Austin"],
    promotions: [], socials: {}, idealCustomer: { summary: "Busy local households" }, localCompetitors: [],
  }) },
  { key: "instagram", label: "Instagram only", input: smbIntakeSchema.parse({
    ...full, externalId: "fixture-instagram-service", brand: { name: "Example Garden Care" },
    socials: { instagram: "https://www.instagram.com/example" }, referenceImages: [],
  }) },
] as const;
